<template>
  <div class="profile-section">
    <section class="toolbar">
      <div class="toolbar-container">
        <router-link id="back-button-cyclerules" v-bind:to="'/operator/home-page'"><img src="/static/images/back.png"></router-link>
        <h1>Cycle Rules</h1>
      </div>
    </section>
    <div class="clearfix"></div>
    <form class="form-inline list-view" id="cycle_form">
      <input type="hidden" name="osid" id="osid" :value="set" />
      <div class="list-view-title">
        <h2> CYCLE</h2>
      </div>
      <div class="tab-container">
        <div class="group">
          <div class="form-group">
            <label for="time_zone"> Cycle Rule</label>
            <div class="select-style">
              <!--<select name="shift_id" v-model="cyclerule.shift" id="shift_id" class="form-control" :change="optionEnabler(cyclerule)">
                <option v-for="shift in data.data.shifts" :key="shift.id" :value="shift" >
                  {{ shift.name }}
                </option>
              </select>-->
              <select v-model="shiftId" name="shift_id" id="shift_id" class="form-control" v-on:change="optionEnabler">
                  <option :id="'shift-'+shift.name" v-for="shift in data.data.shifts" :data-rest-break="shift.rest_break" :data-restart-hour="shift.restart_hour"  :value="shift.id" >
                    {{ shift.name }}
                  </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div v-if="option">
        <div class="list-view-title">
          <h2> OPTIONS</h2>
        </div>
        <div v-if="option_restart" class="tab-container">
          <div class="group">
            <div class="form-group">
              <label for="time_zone"> Restart</label>
              <div class="select-style">
                <select name="restart_hour" v-model="restart_hour" id="option-restart" class="form-control">
                  <option id="restart-24" value="24">24 hour restart</option>
                  <option id="restart-34" value="34">34 hour restart</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div v-if="option_restbreak" class="tab-container">
          <div class="group">
            <div class="form-group">
              <label for="time_zone"> Rest Break</label>
              <div class="select-style">
                <select name="rest_break" v-model="rest_break" id="option-restbreak" class="form-control">
                  <option id="rest-30" value="30">30 minute break</option>
                  <option id="rest-0" value="0">0 minute break</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <input type="text" class="form-control" id="rest" name="data_rest" v-model="data_rest">
              <input type="text" class="form-control" id="restart" name="data_restart" v-model="data_restart">
              <input type="text" class="form-control" id="shift_id" name="shift_id" v-model="shift_id"> -->
    </form>
    <section class="submit-section">
      <button id="saveShiftButton" v-on:click="saveOperatorShift(this)" class="btn btn-default">SAVE</button>
    </section>
  </div>
</template>

<script>
export default {
  name: "cycleRules",
  data: () => ({
    setrestbreak: null,
    setrestarthour: null,
    restart_hour: 24,
    rest_break: 30,
    cyclerule: {},
    shiftId:null,
    option_restart: true,
    option_restbreak: true,
    option: true,
    set: 0,
    data: {
      data: {
        shifts:[], // Empty Data Structure to emulate Data coming from Server
      }
    },
  }),
  mounted: function() {
    this.call();
    
  },
  created: function() { 

  },
  methods: {
    call: function() {
      var self = this;
      self.$config.loading=true;
      $.ajax({
        url: self.$config.API + "/v1/shifts/operator-shift",
        type: "GET",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },timeout: 10000,
        success: function(data) {self.$config.loading=false;
          self.data = data;
          if (self.data.data.selected_shift.length != 0) {
            self.set = self.data.data.selected_shift[0].id;
            self.cyclerule.id = self.data.data.selected_shift[0].shift_id;
            // self.option_restart = self.data.data.selected_shift[0].restart_hour;
            // self.option_restbreak = self.data.data.selected_shift[0].rest_break;
            self.shiftId = self.data.data.selected_shift[0].shift_id;
            self.restart_hour = self.data.data.selected_shift[0].restart_hour;            
            self.rest_break = self.data.data.selected_shift[0].rest_break;          
            
          }
          setTimeout(function(){ self.optionEnabler() }, 50);
          
        },
        error: function(data, textstatus){
self.$config.loading=false;
alert("Retrieval of cycle rule failed : "+textstatus);
        }
      });
    },
    saveOperatorShift: function() {
      var self = this;
      var rest = 0;
      var hour = 0;
      if (self.option_restbreak == true) {
        rest = $("#option-restbreak").val();
      }
      if (self.option_restart == true) {
        hour = $("#option-restart").val();
      }
      self.$config.loading=true;
      $.ajax({
        url: self.$config.API + "/v1/shifts/operator-shift",
        type: "POST",
        data: {
          rest_break: rest,
          restart_hour: hour,
          shift_id: self.shiftId,
          osid: self.set
        },
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },timeout: 10000,
        success: function(data) {self.$config.loading=true;
          if (data.message == "error") {
            alert("There is some error occurred");
          } else if (data.message == "updated") {
            alert("Cycle Rule Updated Successfully.");
          } else {
            self.set = data.message;
            alert("Cycle Rule has been Set Successfully.");
          }
        }, error: function(textstatus){
          self.$config.loading=false;
          alert("Cycle Rule Set failed! Cause : "+textstatus);
        }
      });
    },
    optionEnabler: function() {
      //alert("herer")
      var restBreak = $("#shift_id option:selected").data('rest-break');
      var restartHour = $("#shift_id option:selected").data('restart-hour');

      if (restBreak == 0) {
        this.option_restbreak = false;
      } else {
        this.option_restbreak = true;
      }
      if (restartHour == 0) {
        this.option_restart = false;
      } else {
        this.option_restart = true;
      }
      if (self.option_restbreak == false && self.option_restart == false) {
        this.option = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/cycleRules.vue